module.exports = __webpack_public_path__ + "fef749646facd57efd951f56ba77ef7c.png";